 <div class="transaction-processing">
     <div class="transaction-processing__text">
         {{message}}
     </div>
     <div class="transaction-processing__loader">
         <app-ellipsis-loader></app-ellipsis-loader>
     </div>
 </div>
